import { IBRANSON_FONT_DATA } from './ibranson-font.data'

const STYLE_ATTR = 'data-ibranson-preview-style'
const SCRIPT_ATTR = 'data-ibranson-preview-script'
const BODY_CLASS = 'ibranson-preview-active'
const BODY_ATTR = 'data-ibranson-preview-body'

const STYLESHEETS = [
  'https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css',
  'https://fonts.googleapis.com/css?family=Manrope:400,600,800',
  'https://ibranson.com/fonts/ibransonnew/styles.css',
  'https://ibranson.com/css/main.css?v=7',
  'https://ibranson.com/css/content.css?v=7',
  'https://ibranson.com/css/main-page.css?v=7',
  'https://ibranson.com/assets/fabe93b4/css/schedule-slider.css',
]

let ibransonFontRequested = false

function ensureIbransonFont(): void {
  if (ibransonFontRequested) {
    return
  }
  ibransonFontRequested = true
  ;['ibranson-preview-icons', 'ibransonnew'].forEach((family) => {
    const face = new FontFace(family, `url("${IBRANSON_FONT_DATA}")`)
    face.load().then((loaded) => {
      ;(document.fonts as FontFaceSet & { add(font: FontFace): void }).add(loaded)
    })
  })
}

export function injectIbransonPreviewStyles(): void {
  ensureIbransonFont()
  if (document.head.querySelector(`[${STYLE_ATTR}]`)) {
    return
  }
  STYLESHEETS.forEach((href) => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    link.setAttribute(STYLE_ATTR, '1')
    document.head.appendChild(link)
  })
}

export function removeIbransonPreviewStyles(): void {
  document.head.querySelectorAll(`[${STYLE_ATTR}]`).forEach((el) => el.remove())
}

type MasonryConstructor = new (
  element: Element,
  options?: Record<string, unknown>,
) => { layout: () => void; destroy: () => void; reloadItems?: () => void }

declare global {
  interface Window {
    Masonry?: MasonryConstructor
  }
}

let masonryLoader: Promise<MasonryConstructor | null> | null = null

export function ensureIbransonMasonry(): Promise<MasonryConstructor | null> {
  if (typeof window === 'undefined') {
    return Promise.resolve(null)
  }
  if (window.Masonry) {
    return Promise.resolve(window.Masonry)
  }
  if (masonryLoader) {
    return masonryLoader
  }
  masonryLoader = new Promise((resolve) => {
    const existing = document.querySelector(
      `script[${SCRIPT_ATTR}="masonry"]`,
    ) as HTMLScriptElement | null
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Masonry || null))
      existing.addEventListener('error', () => resolve(null))
      if (window.Masonry) {
        resolve(window.Masonry)
      }
      return
    }
    const script = document.createElement('script')
    script.src = 'https://ibranson.com/js/masonry.pkgd.min.js'
    script.async = true
    script.setAttribute(SCRIPT_ATTR, 'masonry')
    script.onload = () => resolve(window.Masonry || null)
    script.onerror = () => resolve(null)
    document.head.appendChild(script)
  })
  return masonryLoader
}

export function enterIbransonPreviewPage(): void {
  if (!document.body.hasAttribute(BODY_ATTR)) {
    document.body.setAttribute(BODY_ATTR, document.body.className)
  }
  document.body.className = BODY_CLASS
  injectIbransonPreviewStyles()
}

export function leaveIbransonPreviewPage(): void {
  const saved = document.body.getAttribute(BODY_ATTR)
  if (saved !== null) {
    document.body.className = saved
    document.body.removeAttribute(BODY_ATTR)
  } else {
    document.body.classList.remove(BODY_CLASS)
  }
  removeIbransonPreviewStyles()
}
